<template>
  <vs-popup
    :active.sync="activeModal"
    @close="closeModal"
    title="Fotos e Arquivos Deletados"
    id="files-photos-modal"
  >
    <div>
      <div v-if="listImgs.length === 0" class="flex justify-center">
        <h4>Não há itens a serem exibidos para esse filtro.</h4>
      </div>
      <vs-row v-if="listImgs.length > 0" class="mt-5">
        <vs-col
          v-for="item in listImgs"
          :key="item.id"
          type="flex"
          vs-justify="center"
          vs-align="center"
          class="mb-4 w-full sm:w-1/2"
        >
          <vs-card class="bg-danger">
            <div slot="header" class="flex justify-between">
              <h3 class="w-2/3">
                {{ item.nomePosicao }}
              </h3>
            </div>
            <div>
              <div v-if="item.endereco" class="m-2 mb-4" style="clear: both">
                <span v-if="item.nome" class="text-white">
                  <span v-if="validTypeOfEndereco(item.endereco)">{{
                    item.endereco
                  }}</span>
                  <span v-else
                    >{{ item.endereco.road }} -
                    {{ item.endereco.neighbourhood }}
                    {{ item.endereco.city }} / {{ item.endereco.state }}</span
                  >
                  <p v-if="item.dataFotoCaptura">
                    Capturada em:
                    {{ formataData(item.dataFotoCaptura) }}
                  </p>
                  <p v-if="item.dataFotoCaptura">
                    Deletada em:
                    {{ formataData(item.dataExclusao) }}
                  </p>
                </span>
              </div>
              <div
                v-if="item.userUploadedName"
                class="m-2 mb-4"
                style="clear: both"
                :class="`${item.aprovada === null ? '' : 'text-white'}`"
              >
                Upload por: {{ item.userUploadedName }}
              </div>

              <video
                class="video"
                style="max-height: 130px; margin: auto; display: flex"
                v-if="verificaExtensaoVideo(item.nome)"
                controls
                muted
                loop
                :src="item.nome"
              ></video>

              <img
                v-if="verificaExtensaoImagem(item.nome)"
                :src="item.nome"
                class="foto"
                width="100%"
              />

              <div
                v-else-if="!verificaExtensaoVideo(item.nome)"
                class="flex flex-col items-center"
              >
                <img
                  class="foto"
                  width="80%"
                  src="../../assets/images/elements/PDF_file_icon2.png"
                />
                <a :href="item.nome" target="_blank">{{
                  formataUrlLink(item.nome)
                }}</a>
              </div>

              <div v-if="item.observacaoVistoria">
                <span class="text-white"><b>Observação:</b></span>
                <p class="text-white break-words">
                  {{ item.observacaoVistoria }}
                </p>
              </div>

              <h5
                v-if="item.aprovada === false"
                class="text-center text-white p-4 mb-3"
              >
                {{ item.motivoReprovacao }}
              </h5>

              <h5
                v-if="item.aprovada === false"
                class="text-center text-white p-4 mb-3"
              >
                {{ item.motivoExclusao }}
              </h5>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  name: 'ModalListImgs',
  props: {
    imgs: {
      type: Array,
    },
    openModal: {
      type: Boolean,
    },
  },
  watch: {
    openModal(value) {
      if (value) {
        this.showModal();
      }
    },
  },
  data() {
    return {
      activeModal: false,
      listImgs: [],
    };
  },
  methods: {
    /**
     * Closes the modal and emits a 'close' event.
     */
    closeModal() {
      this.activeModal = false;
      this.$emit('close');
    },

    /**
     * Checks if the provided link is a data image or a supported image format.
     * @param {string} link - The link to check.
     * @returns {boolean} - True if the link is a data image or supported image format, false otherwise.
     */
    verificaExtensaoImagem(link) {
      if (link) {
        const hasDataImage = link.split('/')[0] === 'data:image';
        if (hasDataImage) {
          return hasDataImage;
        }
        const extension = link.split('.').pop();
        this.tipoFoto = extension;
        const isPhoto =
          extension === 'png' ||
          extension === 'jpeg' ||
          extension === 'jpg' ||
          extension === 'gif';
        return isPhoto;
      }
      return false;
    },

    /**
     * Checks if the provided link is a data video or a supported video format.
     * @param {string} link - The link to check.
     * @returns {boolean} - True if the link is a data video or supported video format, false otherwise.
     */
    verificaExtensaoVideo(link) {
      if (link) {
        const hasDataVideo = link.split('/')[0] === 'data:video';
        if (hasDataVideo) {
          return hasDataVideo;
        }
        const extension = link.split('.').pop();
        this.tipoFoto = extension;
        const isVideo =
          extension === 'gif' ||
          extension === 'mp4' ||
          extension === 'webm' ||
          extension === 'quicktime';
        return isVideo;
      }
      return false;
    },

    /**
     * Formats the given URL link.
     * @param {string} url - The URL to format.
     * @returns {string} - The formatted URL.
     */
    formataUrlLink(url) {
      if (url) return url.split('/').pop();
    },

    /**
     * Checks if the photo has been updated and returns the formatted date.
     * @param {Date} dataCriacao - The creation date.
     * @param {Date} dataAtualizacao - The update date.
     * @returns {string} - The formatted date.
     */
    verificaSefotoFoiAtualizada(dataCriacao, dataAtualizacao) {
      const fotoFoiAtualizada =
        dayjs(dataCriacao).format('YYYYMMDDHHMMSS') ===
        dayjs(dataAtualizacao).format('YYYYMMDDHHMMSS');

      const dataFoto = !fotoFoiAtualizada
        ? this.ajustaDataHoraUtc(dataAtualizacao)
        : this.ajustaDataHoraUtc(dataCriacao);

      return dataFoto;
    },

    /**
     * Formats the given date.
     * @param {Date} data - The date to format.
     * @returns {string} - The formatted date.
     */
    formataData(data) {
      const dateBrWithHour = dayjs(data).format('DD/MM/YYYY HH:mm');
      return dateBrWithHour;
    },

    /**
     * Adjusts the date and time to local time zone from UTC.
     * @param {Date} data - The UTC date to adjust.
     * @returns {string} - The adjusted date and time.
     */
    ajustaDataHoraUtc(data) {
      const dateBrWithHour = dayjs.utc(data).local().format('DD/MM/YYYY HH:mm');
      return dateBrWithHour;
    },

    /**
     * Checks if the provided item is a string.
     * @param {any} item - The item to check.
     * @returns {boolean} - True if the item is a string, false otherwise.
     */
    validTypeOfEndereco(item) {
      const isString = typeof item === 'string';
      return isString;
    },

    /**
     * Sets the list of images and shows the modal.
     */
    showModal() {
      this.listImgs = this.imgs;
      this.activeModal = true;
    },
  },
};
</script>

<style lang="css"></style>
